export const FILTER_TYPES = {
  numeric: 'numeric',
  date: 'date',
  string: 'string',
  enum: 'enum',
  lookup: 'lookup'
}
const NUMERIC_OPTIONS = [
  { name: 'equal', id: 'eq', isDefault: true },
  { name: 'not-equal', id: 'neq' },
  { name: 'less-than', id: 'lt' },
  { name: 'less-or-equal', id: 'lte' },
  { name: 'greater-or-equal', id: 'gte' },
  { name: 'greater-than', id: 'gt' }
]
const STRING_OPTIONS = [
  { name: 'startswith', id: 'startswith' },
  { name: 'endswith', id: 'endswith' },
  { name: 'contains', id: 'contains', isDefault: true },
  { name: 'doesnotcontain', id: 'doesnotcontain' },
  { name: 'isempty', id: 'isempty' },
  { name: 'isnotempty', id: 'isnotempty' }
]
const NULLABLE_OPTIONS = [
  { name: 'is-null', id: 'isnull' },
  { name: 'is-not-null', id: 'isnotnull' },

]
const ENUM_OPTIONS = [
  { name: 'equal', id: 'eq', isDefault: true },
  { name: 'not-equal', id: 'neq' }
]
const FILTER_OPTIONS = {
  [FILTER_TYPES.numeric]: [ ...NUMERIC_OPTIONS ],
  [FILTER_TYPES.date]: [ ...NUMERIC_OPTIONS, ...NULLABLE_OPTIONS ],
  [FILTER_TYPES.string]: [ ...STRING_OPTIONS ],
  [FILTER_TYPES.enum]: [ ...ENUM_OPTIONS ],
  [FILTER_TYPES.lookup]: [ ...ENUM_OPTIONS ]
}

export const createFilterOptions = (type, localize) => FILTER_OPTIONS[type].map(x => ({ ...x, name: localize(`filters.${type}_${x.name}`) }))
export const findDefaultOption = (type) => FILTER_OPTIONS[type].find(x => x.isDefault)

const hasValue = (x) => {
  if (x.type === FILTER_TYPES.string) {
    if (x.option.id === 'isempty' || x.option.id === 'isnotempty') { return true }
  }
  else if (x.type === FILTER_TYPES.date) {
    if (x.option.id === 'isnull' || x.option.id === 'isnotnull') { return true }
  }
  return x.value !== null && (!Array.isArray(x.value) || x.value.length > 0)
}

export const calculateFilters = (columns, filterTypes) => {
  const filters = columns.filter(x => hasValue(x)).map(x => {
    if (Array.isArray(x.value)) {
      return {
        filters: x.value.map(y => ({
          field: x.id,
          operator: x.option.id,
          value: (x.type === FILTER_TYPES.lookup ? y.id : y)
        })),
        logic: (x.logic === 0 ? 'or' : 'and')
      }
    }
    return {
      field: x.id,
      operator: x.option.id,
      value: x.value
    }
  })
  return filters
}
